import React, { Component } from "react";
import { sendLog } from "@lambdatest/frontend-logger";

import styles from "./index.module.css";

const DEFAULT_MSG_TO_DISPLAY = `Something went wrong. There were some issues while rendering the component. 
  Please reload and try again`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    sendLog({
      logDetails: {
        componentName: "Error Boundary",
        error: String(error),
        componentStack: errorInfo
      },
      logLevel: "Error",
      serviceName: "MagicLeap - Dashboard"
    });
  }

  render() {
    const {
      heightToSet = "100vh",
      msgToDisplay = DEFAULT_MSG_TO_DISPLAY
    } = this.props;
    if (this.state.hasError) {
      return (
        <div
          className={styles.errorBoundaryWrapper}
          style={{
            height: heightToSet
          }}
        >
          <div>{msgToDisplay}</div>
          <div
            className={styles.reloadButton}
            data-testid="error-reload-btn"
            onClick={() => window.location.reload()}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && window.location.reload()}
            role="button"
            tabIndex={0}
          >
            Reload
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
